import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Form,
	Button,
	Input,
	Checkbox,
} from 'antd'
import {
	CommonValue,
	confirm,
	message,
	notify,
	alert,
	pcUrl,
	scanPost,
} from '@/utils/Tools';
import {
	Html5Qrcode,
	Html5QrcodeSupportedFormats
} from 'html5-qrcode';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'adminInfo':{},
			'showMask':false,
		};
	}
	
	componentDidMount()
	{
		document.title = '配送扫码';
		global.setScanState({
			'headScope':{
				'leftButton':null,
				'title':'配送扫码',
				'rightButton':(
					<a href="javascript:;" className="text-red" onClick={()=>this.logout()}>
						退出登录
					</a>
				),
			},
		});
		
		let adminInfo = CommonValue.get('admin_info');
		this.setState({
			adminInfo
		});
	}
	
	logout()
	{
		confirm('确认要退出登录')
			.then(()=>{
				let url = pcUrl('index','adminLogout');
				scanPost(url)
					.then(this.props.history.push('/scan/login'));
			});
	}
	
	scan(status)
	{
		let messages = {
			10:'配送区扫码',
			20:'装车扫码',
			30:'送达扫码',
		};
		
		/*
		let _next = ()=>{
				//let url = 'http://b2b-print.test.com/user/#/package/11_1_59';
				let url = 'http://b2b-print.test.com/user/#/package/10_1_141';
				//获取订单数据
				url = url.split('/');
				let id = url.pop();
				id = id.split('_');
				if(id.length != 3)
				{
					notify('二维码格式不正确，请确认','error');
					return;
				}
				let packageId = id[0];
				let siteId = id[1];
				let orderId = id[2];
				
				//更新服务器状态
				url = pcUrl('scan','changeStatus');
				let param = {
					'package_id':packageId,
					'site_id':siteId,
					'shipping_status':status,
				};
				scanPost(url,param)
					.then(()=>{
						//notify('订单'+messages[status]+'成功');
						
						//进入图片上传页
						if(status == 30)
						{
							message('订单'+messages[status]+'成功，请上传拍照图片','success');
							this.props.history.push('/scan/photo/'+packageId+'_'+siteId);
						}
						else
							message('订单'+messages[status]+'成功','success');
					});
		};
		_next();
		return;
		*/
		
		this._scan()
			.then(url=>{
				//获取订单数据
				url = url.split('/');
				let id = url.pop();
				id = id.split('_');
				if(id.length != 3)
				{
					notify('二维码格式不正确，请确认','error');
					return;
				}
				let packageId = id[0];
				let siteId = id[1];
				let orderId = id[2];
				
				//更新服务器状态
				url = pcUrl('scan','changeStatus');
				let param = {
					'package_id':packageId,
					'site_id':siteId,
					'shipping_status':status,
				};
				scanPost(url,param)
					.then(()=>{
						//notify('订单'+messages[status]+'成功');
						
						//进入图片上传页
						if(status == 30)
						{
							message('订单'+messages[status]+'成功，请上传拍照图片','success');
							this.props.history.push('/scan/photo/'+packageId+'_'+siteId);
						}
						else
							message('订单'+messages[status]+'成功','success');
					});
			});
	}
	
	_scan()
	{
		let windowWidth = $(window).width();
		let windowHeight = $(window).height();
		
		return new Promise((resolve,reject)=>{
			this.setState({
				'showMask':true,
			},()=>{
				Html5Qrcode.getCameras()
					.then(devices=>{
						if(devices && devices.length > 0)
						{
							let html5Qrcode = new Html5Qrcode('reader',{ formatsToSupport: [ Html5QrcodeSupportedFormats.QR_CODE ] });
							html5Qrcode.start({
								facingMode:"environment",
							},{
								//fps: 10, qrbox: { width: windowWidth*3 /4, height: windowWidth*windowWidth*3 /(4*windowHeight) }
								fps: 10, qrbox: { width: 300, height: 300 }
							},(decodeText,decodeResult)=>{
								resolve(decodeText);
								this.setState({
									'showMask':false,
								});
								//alert(JSON.stringify(decodeResult));
								html5Qrcode.stop();
							});
						}
					})
					.catch(e=>{
						alert(JSON.stringify(e));
						this.setState({
							'showMask':false,
						});
						reject(e);
					})
			});
		});
	}
	
	render()
	{
		return (
		<>
			<div className="m-scan">
				<div className="m-body">
					<h3>
						用户名：{this.state.adminInfo['admin_name']}
					</h3>
					<div class="desc">
						请严格按照要求对每个步骤进行扫码，确保配送信息被正确更新，精准服务好凹鱼客户，谢谢
					</div>
					<div class="m-button-list">
						<ul>
							<li>
								<Button className="orange" type="primary" size="large" onClick={()=>this.scan(10)}>配送区扫码</Button>
							</li>
							<li>
								<Button className="red" type="primary" size="large" onClick={()=>this.scan(20)}>装车扫码</Button>
							</li>
							<li>
								<Button className="green" type="primary" size="large" onClick={()=>this.scan(30)}>送达扫码</Button>
							</li>
							{/*
							<li>
								<Button className="blue" type="primary" size="large">拍照留存</Button>
							</li>
							*/}
						</ul>
					</div>
				</div>
			</div>
			
			{this.state.showMask && (
				<div class="m-mask">
					<div class="m-reader" id="reader"></div>
				</div>
			)}
		</>
		);
	}
}

